import * as React from "react";

import { default as TriggerInput, InputMode } from "./TriggerInput";

export class TypedTriggerInput<T> extends React.PureComponent<TypedTriggerInputProps<T>, Record<string, never>> {
    public render(): JSX.Element {
        return <TriggerInput
            elementId={this.props.elementId}
            existingParameters={this.props.parameters}
            name={this.props.parameterName}
            inputMode={this.props.inputMode}
            disabled={this.props.disabled}
            label={this.props.label}
            description={this.props.description}
            minValue={this.props.minValue}
            isSecret={this.props.isSecret}
        />;
    }
}

export interface TypedTriggerInputProps<T> {
    elementId: string;
    parameters: T;
    parameterName: keyof (T) & string;
    inputMode: InputMode;
    disabled?: boolean;
    label?: string;
    minValue?: number;
    description?: string;
    isSecret?: boolean;
}
